function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.14495,
  cy: 8.19182,
  r: 7.48675,
  fill: "white",
  fillOpacity: 0.51
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.918 5.79426C10.918 7.23366 9.76391 8.38783 8.32349 8.38783C6.88356 8.38783 5.72897 7.23366 5.72897 5.79426C5.72897 4.35485 6.88356 3.20117 8.32349 3.20117C9.76391 3.20117 10.918 4.35485 10.918 5.79426ZM8.32305 13.003C6.19723 13.003 4.40234 12.6575 4.40234 11.3244C4.40234 9.99087 6.20851 9.65761 8.32305 9.65761C10.4494 9.65761 12.2438 10.0031 12.2438 11.3362C12.2438 12.6697 10.4376 13.003 8.32305 13.003Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8899 4.91994H14.4797V6.36748H13.4947V4.91994H12.0845V4.00963H13.4947V2.56209H14.4797V4.00963H15.8899V4.91994Z",
  fill: "black"
});

function SvgAdduser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdduser);
export default __webpack_public_path__ + "static/media/adduser.fb41ba89.svg";
export { ForwardRef as ReactComponent };